module.exports = __webpack_public_path__ + "img/71.1aa119d2.jpg";